// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"2a54181d","302":"c050d5ed","567":"15beaaff","629":"78f11720","694":"61b5ae59","737":"dde8eaf4","854":"6a4898b9","962":"416bb3ec"}[chunkId] + ".chunk.js";
};